// import React from "react";
// import { Link } from "react-router-dom";
import React, { useEffect } from "react";                    // ⬅ added useEffect
import { Link, useLocation } from "react-router-dom"; 
import CampaignBanner from "../components/individual/Home/Campaignbanner";
import styles from "./styles/Campaignbannerpage.module.css";
import handshakeIcon from "../assets/campaign/Handshake.png";
import mspTrialApplicationPdf from "../assets/campaign/MSPサービストライアル申込書_お申込みにあたって確認事項v1.0_20260801.pdf";

/**
 * CampaignbannerPage
 * Detailed landing page for the "2週間無料トライアル" campaign.
 * Reached via the "無料オンライン相談の申し込み" button on CampaignBanner
 * (route: /jp/campaign-page).
 *
 * TODO: replace CONSULTATION_LINK with the actual Calendly booking URL.
 */
const CONSULTATION_LINK = "https://outlook.office.com/bookwithme/user/e005431dda2242eca3b9d90fe7411a20@dgfuturetech.com/meetingtype/VNymjJqM90q3bWWARqKoFA2?anonymous&ep=mCardFromTile";

/* ------------------------------------------------------------------ */
/* Icon set — flat, two-tone SVGs (no emoji) matching the reference   */
/* ------------------------------------------------------------------ */

const IconPackage = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
    <path d="M12 2 L21 6.5 V17.5 L12 22 L3 17.5 V6.5 Z" fill="#F4A340" />
    <path d="M12 2 L21 6.5 L12 11 L3 6.5 Z" fill="#FBC272" />
    <path d="M12 11 V22" stroke="#D9822B" strokeWidth="1" />
  </svg>
);

const IconLaptop = () => (
  <svg viewBox="0 0 64 64" width="36" height="36">
    <defs>
      <linearGradient id="screenGrad" x1="0" y1="0" x2="0.3" y2="1">
        <stop offset="0" stopColor="#5B93FF" />
        <stop offset="1" stopColor="#1B3FA8" />
      </linearGradient>
    </defs>
    <rect x="9" y="10" width="46" height="32" rx="4" fill="#152C6B" />
    <rect x="12.5" y="13.5" width="39" height="25" rx="2" fill="url(#screenGrad)" />
    <rect x="16" y="17" width="18" height="1.8" rx="0.9" fill="#ffffff" opacity="0.55" />
    <path
      d="M4 45c0-1.8 1.4-3.2 3.2-3.2h49.6c1.8 0 3.2 1.4 3.2 3.2 0 1.7-1.4 3-3.2 3H7.2C5.4 48 4 46.7 4 45z"
      fill="#152C6B"
    />
    <rect x="26" y="44.3" width="12" height="1.6" rx="0.8" fill="#E7ECF7" />
  </svg>
);

const IconBell = () => (
  <svg viewBox="0 0 64 64" width="34" height="34">
    <path
      d="M32 8c-8 0-13 6-13 14v8c0 4-4 6-4 10h34c0-4-4-6-4-10v-8c0-8-5-14-13-14z"
      fill="#F5A623"
    />
    <circle cx="32" cy="8" r="3.4" fill="#F5A623" />
    <path d="M25 44a7 7 0 0 0 14 0z" fill="#D9822B" />
  </svg>
);

const IconPeople = () => (
  <svg viewBox="0 0 64 64" width="36" height="36">
    <circle cx="24" cy="22" r="8" fill="#8B5CF6" />
    <path d="M8 50c0-10 7-16 16-16s16 6 16 16" fill="#8B5CF6" />
    <circle cx="42" cy="20" r="6.5" fill="#C4B0F5" />
    <path d="M32 50c1-8 7-13 15-13s13 5 14 13" fill="#C4B0F5" />
  </svg>
);

const IconMoon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <path
      d="M15 3a9 9 0 1 0 6 15 8 8 0 0 1-6-15z"
      fill="#FFFFFF"
    />
    <circle cx="18" cy="6" r="0.8" fill="#FFFFFF" />
    <circle cx="20" cy="10" r="0.5" fill="#FFFFFF" />
  </svg>
);

const IconSun = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <circle cx="12" cy="12" r="5" fill="#FFFFFF" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
      <line
        key={deg}
        x1="12"
        y1="2.5"
        x2="12"
        y2="4.8"
        stroke="#FFFFFF"
        strokeWidth="1.4"
        strokeLinecap="round"
        transform={`rotate(${deg} 12 12)`}
      />
    ))}
  </svg>
);

const IconBuildings = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <rect x="3" y="10" width="6" height="11" fill="#FFFFFF" />
    <rect x="10" y="5" width="6" height="16" fill="#FFFFFF" />
    <rect x="17" y="13" width="4" height="8" fill="#FFFFFF" />
    <rect x="4.5" y="12" width="1.4" height="1.4" fill="#0F6B5C" />
    <rect x="4.5" y="15" width="1.4" height="1.4" fill="#0F6B5C" />
    <rect x="11.5" y="7" width="1.4" height="1.4" fill="#0F6B5C" />
    <rect x="11.5" y="10" width="1.4" height="1.4" fill="#0F6B5C" />
    <rect x="11.5" y="13" width="1.4" height="1.4" fill="#0F6B5C" />
  </svg>
);

const IconClock = () => (
  <svg viewBox="0 0 64 64" width="64" height="64">
    {/* Face */}
    <circle cx="32" cy="32" r="30" fill="#ffffff" stroke="#dbe4f3" strokeWidth="2" />

    {/* Tick marks at 12, 3, 6, 9 */}
    <line x1="32" y1="6" x2="32" y2="11" stroke="#0B1E3D" strokeWidth="2.2" strokeLinecap="round" />
    <line x1="58" y1="32" x2="53" y2="32" stroke="#0B1E3D" strokeWidth="2.2" strokeLinecap="round" />
    <line x1="32" y1="58" x2="32" y2="53" stroke="#0B1E3D" strokeWidth="2.2" strokeLinecap="round" />
    <line x1="6" y1="32" x2="11" y2="32" stroke="#0B1E3D" strokeWidth="2.2" strokeLinecap="round" />

    {/* Hour hand */}
    <line x1="32" y1="32" x2="20" y2="25" stroke="#0B1E3D" strokeWidth="3.2" strokeLinecap="round" />
    {/* Minute hand */}
    <line x1="32" y1="32" x2="49" y2="22" stroke="#0B1E3D" strokeWidth="2.6" strokeLinecap="round" />

    {/* Center pin */}
    <circle cx="32" cy="32" r="3.4" fill="#0B1E3D" />
  </svg>
);

const IconCycleArrow = ({ flip }) => (
  <svg
    viewBox="0 0 40 40"
    width="30"
    height="30"
    style={{ transform: flip ? "scaleX(-1) scaleY(-1)" : "none" }}
  >
    <path
      d="M6 20a14 14 0 0 1 24-9.7"
      fill="none"
      stroke="#B9C3D6"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
    <path d="M30 4 L30 12 L22 10 Z" fill="#B9C3D6" />
  </svg>
);

const IconCheckFilled = ({ size = 18, bg = "#2E5BE8" }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} style={{ flexShrink: 0 }}>
    <circle cx="12" cy="12" r="11" fill={bg} />
    <path
      d="M7 12.5l3 3 6.5-7"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconDocument = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <path d="M6 2h9l3 3v17H6z" fill="#ffff" />
    <path d="M15 2v3h3z" fill="#0449f7" />
    <line x1="8.5" y1="11" x2="15.5" y2="11" stroke="#0449f7" strokeWidth="1" />
    <line x1="8.5" y1="14" x2="15.5" y2="14" stroke="#0449f7" strokeWidth="1" />
  </svg>
);

const IconGear = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <path
      d="M12 3l1.2 2.3 2.5-.7 1 2.4 2.5.6-.3 2.5 1.9 1.7-1.9 1.7.3 2.5-2.5.6-1 2.4-2.5-.7L12 21l-1.2-2.3-2.5.7-1-2.4-2.5-.6.3-2.5-1.9-1.7 1.9-1.7-.3-2.5 2.5-.6 1-2.4 2.5.7z"
      fill="#5B6B82"
    />
    <circle cx="12" cy="12" r="3.4" fill="#FFFFFF" />
  </svg>
);

const IconTarget = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <circle cx="12" cy="12" r="9" fill="#E8493B" />
    <circle cx="12" cy="12" r="6" fill="#FFFFFF" />
    <circle cx="12" cy="12" r="3" fill="#E8493B" />
  </svg>
);

const IconPlay = () => (
  <svg viewBox="0 0 24 24" width="32" height="40">
    <path d="M6 4l14 8-14 8z" fill="#1F4ED8" />
  </svg>
);

const IconClipboard = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <rect x="4" y="3" width="16" height="19" rx="2" fill="none" stroke="#1F4ED8" strokeWidth="1.6" />
    <rect x="8" y="1.5" width="8" height="4" rx="1" fill="#1F4ED8" />
    <line x1="7.5" y1="10" x2="16.5" y2="10" stroke="#1F4ED8" strokeWidth="1.4" />
    <line x1="7.5" y1="14" x2="16.5" y2="14" stroke="#1F4ED8" strokeWidth="1.4" />
    <line x1="7.5" y1="18" x2="13" y2="18" stroke="#1F4ED8" strokeWidth="1.4" />
  </svg>
);

const IconHandshakeSmall = () => (
  <svg viewBox="0 0 100 100" width="28" height="28">
    {/* Left sleeve (cuff) */}
    <path
      d="M6 40 L27 17 C28.7 15.2 31.5 15.2 33.2 17 L41 25.2 L20 47.8 C18.3 49.6 15.5 49.6 13.8 47.8 L6 40 Z"
      fill="#1263B3"
    />
    {/* Right sleeve (cuff) */}
    <path
      d="M94 40 L73 17 C71.3 15.2 68.5 15.2 66.8 17 L59 25.2 L80 47.8 C81.7 49.6 84.5 49.6 86.2 47.8 L94 40 Z"
      fill="#1263B3"
    />
    {/* Left forearm leading into hand */}
    <path
      d="M23 45 L39.5 27.3 C40.6 26.1 42.4 26.1 43.5 27.3 L47.5 31.6 C48.7 32.9 48.6 34.9 47.3 36.1 L46.7 36.6 C45.4 37.8 43.4 37.7 42.3 36.4 L40.6 34.6 L26 50.4 Z"
      fill="#1263B3"
    />
    {/* Right forearm leading into hand, with thumb notch */}
    <path
      d="M77 45 L60.5 27.3 C59.4 26.1 57.6 26.1 56.5 27.3 L52.7 31.4 C51.2 33 51.4 35.5 53.1 36.8 C54.6 38 56.7 37.8 58 36.4 L59.4 34.9 L74 50.4 Z"
      fill="#1263B3"
    />
    {/* Palm connector */}
    <path
      d="M38 40 L48 51 C49.5 52.7 49.4 55.2 47.8 56.8 L45.5 59 L33 46 Z"
      fill="#1263B3"
    />
    <path
      d="M62 40 L52 51 C50.5 52.7 50.6 55.2 52.2 56.8 L54.5 59 L67 46 Z"
      fill="#1263B3"
    />
    {/* Interlocked fingers — 4 rounded diagonal bars, white gaps between them */}
    <path
      d="M31 51 C29 49 25.8 49 23.8 51 L16.5 58.3 C14.5 60.3 14.5 63.5 16.5 65.5 C18.5 67.5 21.7 67.5 23.7 65.5 L37 52.3 Z"
      fill="#1263B3"
    />
    <path
      d="M41 60 C39 58 35.8 58 33.8 60 L25.5 68.3 C23.5 70.3 23.5 73.5 25.5 75.5 C27.5 77.5 30.7 77.5 32.7 75.5 L47 61.3 Z"
      fill="#1263B3"
    />
    <path
      d="M51 69 C49 67 45.8 67 43.8 69 L35.5 77.3 C33.5 79.3 33.5 82.5 35.5 84.5 C37.5 86.5 40.7 86.5 42.7 84.5 L57 71.3 Z"
      fill="#1263B3"
    />
    <path
      d="M60 60 L60.5 60.5 C67.2 67.2 73.9 73.9 80.6 80.6 C82.5 82.5 82.6 85.5 80.7 87.3 C78.7 89.2 75.5 89.1 73.6 87.1 L47.5 61 Z"
      fill="#1263B3"
    />
  </svg>
);


const IconSearch = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="#1F4ED8" strokeWidth="1.8" />
    <line x1="15.5" y1="15.5" x2="21" y2="21" stroke="#1F4ED8" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconBarChart = () => (
  <svg viewBox="0 0 24 24" width="28" height="28">
    <rect x="4" y="13" width="4" height="8" fill="#2E6BF0" />
    <rect x="10" y="8" width="4" height="13" fill="#2E6BF0" />
    <rect x="16" y="3" width="4" height="18" fill="#2E6BF0" />
  </svg>
);

// const IconHandshake = () => (
//   <svg viewBox="0 0 24 24" width="28" height="28">
//     <path
//       d="M2 12l5-4 4 2 3-2 4 3 4-2v6l-4 3-3-2-3 2-6-3z"
//       fill="#16A34A"
//     />
//   </svg>
// );

const IconGift = () => (
  <svg viewBox="0 0 24 24" width="28" height="28">
    <rect x="4" y="10" width="16" height="11" fill="#F5A623" />
    <rect x="3" y="7" width="18" height="4" fill="#F4C773" />
    <rect x="11" y="7" width="2" height="14" fill="#D9822B" />
    <path d="M12 7c-2-5-8-3-6 0z" fill="#D9822B" />
    <path d="M12 7c2-5 8-3 6 0z" fill="#D9822B" />
  </svg>
);

const IconEnvelope = () => (
  <svg viewBox="0 0 24 24" width="24" height="24">
    <rect x="2" y="5" width="20" height="14" rx="2" fill="#2E6BF0" />
    <path d="M2 6l10 8 10-8" fill="none" stroke="#FFFFFF" strokeWidth="1.6" />
  </svg>
);

/* ------------------------------------------------------------------ */

const packageCards = [
  {
    key: "monitor",
    iconClass: "cardIcon_monitor",
    underlineClass: "cardUnderline_monitor",
    icon: <IconLaptop />,
    title: "サーバ１台またはアプリケーション１つを監視",
    text: "選定したサーバ１台またはアプリケーション１つを１シフト8時間、どの時間帯でも監視します。",
  },
  {
    key: "alert",
    iconClass: "cardIcon_alert",
    underlineClass: "cardUnderline_alert",
    icon: <IconBell />,
    title: "運用担当者がリアルタイムにアラートを通知",
    text: "Criticalアラートを検知後、ご指定のビジネスチャットへ即座に通知します。",
  },
  {
    key: "shared",
    iconClass: "cardIcon_shared",
    underlineClass: "cardUnderline_shared",
    icon: <IconPeople />,
    title: "標準化された運用監視基盤を利用",
    text: "標準化された共通運用基盤を使うことで短期間かつ低コストでサービス品質を検証いただけます。",
  },
];

//Change 2026-08-13 : Old code for 3 cards
/*
const flowSteps = [
  { num: "01", label: "申込・初期情報の提供" ,icon: <IconClipboard />},
  { icon: <img src={handshakeIcon} alt="" width={28} height={28} />, num: "02", label: "受付完了・双方合意", },
  { num: "03", label: "2週間検証＆レビュー" ,icon: <IconSearch />},
];
*/

//Change 2026-08-13 : New code for 4 cards with title and description
const flowSteps = [
  {
    num: "1",
    title: "申込・対象条件の提出",
    description: "NDA入り申込書でスムースなお申込み",
    icon: <IconClipboard />,
  },
  {
    num: "2",
    title: "監視条件・KPIの合意",
    description: "必要情報を専用入力フォームに簡単登録",
    icon: <img src={handshakeIcon} alt="" width={28} height={28} />,
  },
  {
    num: "3",
    title: "2週間の無料トライアル実施",
    description: "当社のサービス品質をご実感ください",
    icon: <IconSearch />,
  },
  {
    num: "4",
    title: "結果レビュー・正式提案",
    description: "初年度10％割引適応をお見逃しなく",
    icon: <IconBarChart />,
  },
]; 


const benefits = [
  { icon: <IconBarChart />, text: "当社サービスレベルを事前体験可能" },
  { icon: <img src={handshakeIcon} alt="" width={28} height={28} />, text: "スムーズな本契約、サービス提供への移行" },
  { icon: <IconGift />, text: "本契約は10%OFF（1年目）", highlight: true },
];

const notes = [
  {
    label: "自動課金なし",
    text: "トライアル終了後に自動で有料契約へ移行することはございません。",
  },
  {
    label: "シェアード提供",
    text: "本サービスは共通リソースを共有する仕組みのため、個別手順の個別カスタマイズは対象外です。",
  },
  {
    label: "トライアル後正式ご提案",
    text: "トライアルは限定範囲での検証です。終了後は改めてお打合せを実施し最適な対象範囲とお見積りをご提案します。",
  },
  {
    label: "申込書兼オンライン同意",
    text: "下に添付されたPDF「MSPサービストライアル申込書 お申込みにあたって確認事項V1.0」内の申込同意（秘密保持・免責等）へのチェック、および双方の署名・当社受付印がそろった「申込書コピー」の受領をもって、別途契約なしで正式受付となります。",
  },
];

const CampaignbannerPage = () => {
  const location = useLocation();

  useEffect(() => {
  if (location.hash) {
    const timeoutId = setTimeout(() => {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 150); // slightly after ScrollToTop's 100ms, so it can't override us

    return () => clearTimeout(timeoutId);
  }
}, [location]);
  return (
    <div className={styles.page}>
      {/* Banner at the top */}
      <CampaignBanner />

      {/* Package contents */}
      <section className={styles.section} id="trial-scope-section"></section>
      <section className={styles.section}>
        <h2 className={styles.packageTitle}>
          <span className={styles.packageIcon}>
            <IconPackage />
          </span>
          無料トライアルの対象範囲
        </h2>
        <div className={styles.cardsRow}>
          {packageCards.map((c) => (
            <div className={styles.card} key={c.key}>
              <div className={styles.cardHeader}>
                <div className={`${styles.cardIcon} ${styles[c.iconClass]}`}>
                  {c.icon}
                </div>
                <div className={styles.cardTitle}>{c.title}</div>
              </div>
              <div className={`${styles.cardUnderline} ${styles[c.underlineClass]}`} />
              <div className={styles.cardText}>{c.text}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Two-column: shift chart + flow/benefits */}
      <section className={`${styles.section} ${styles.twoColumn}`}>
        {/* Left: shift donut */}
        <div className={styles.panel}>
          <div className={styles.panelHeader}>1シフト8時間／追加料金なし</div>
          <div className={styles.panelBody}>
            <div className={styles.pieWrap}>
      
              <svg
  viewBox="0 0 300 300"
  className={styles.pieSvg}
  role="img"
  aria-label="日中・夕方・深夜のシフト時間帯"
>
  <path
    d="M150,150 L150,10 A140,140 0 0,1 271.24,220 Z"
    fill="#1B4FD1"
    stroke="#ffffff"
    strokeWidth="4"
  />
  <path
    d="M150,150 L271.24,220 A140,140 0 0,1 28.76,220 Z"
    fill="#0F6B5C"
    stroke="#ffffff"
    strokeWidth="4"
  />
  <path
    d="M150,150 L28.76,220 A140,140 0 0,1 150,10 Z"
    fill="#0B1E3D"
    stroke="#ffffff"
    strokeWidth="4"
  />

  {/* Cycle arrow — 日中 (top-right section) */}
  <path
    d="M233.2,31.2 A145,145 0 0,1 294.5,137.4"
    fill="none"
    stroke="#D4DCEC"
    strokeWidth="4"
    strokeLinecap="round"
  />
  <polygon
    points="294.5,133.4 294.5,141.4 302.5,137.4"
    fill="#D4DCEC"
    transform="rotate(85 294.5 137.4)"
  />

  {/* Cycle arrow — 夕方 (bottom section) */}
  <path
    d="M211.3,281.4 A145,145 0 0,1 88.7,281.4"
    fill="none"
    stroke="#D4DCEC"
    strokeWidth="4"
    strokeLinecap="round"
  />
  <polygon
    points="88.7,277.4 88.7,285.4 96.7,281.4"
    fill="#D4DCEC"
    transform="rotate(205 88.7 281.4)"
  />

  {/* Cycle arrow — 深夜 (top-left section) */}
  <path
    d="M5.5,137.4 A145,145 0 0,1 66.8,31.2"
    fill="none"
    stroke="#D4DCEC"
    strokeWidth="4"
    strokeLinecap="round"
  />
  <polygon
    points="66.8,27.2 66.8,35.2 74.8,31.2"
    fill="#D4DCEC"
    transform="rotate(325 66.8 31.2)"
  />

  <circle cx="150" cy="150" r="34" fill="#ffffff" />

  <foreignObject x="163" y="60" width="110" height="70">
    <div xmlns="http://www.w3.org/1999/xhtml" className={styles.pieLabel}>
      <IconSun />
      <span className={styles.pieLabelText}>日中</span>
      <span className={styles.pieLabelTime}>09:00 ～ 17:00</span>
    </div>
  </foreignObject>
  <foreignObject x="95" y="205" width="110" height="70">
    <div xmlns="http://www.w3.org/1999/xhtml" className={styles.pieLabel}>
      <IconBuildings />
      <span className={styles.pieLabelText}>夕方</span>
      <span className={styles.pieLabelTime}>17:00 ～ 01:00</span>
    </div>
  </foreignObject>
  <foreignObject x="27" y="60" width="110" height="70">
    <div xmlns="http://www.w3.org/1999/xhtml" className={styles.pieLabel}>
      <IconMoon />
      <span className={styles.pieLabelText}>深夜</span>
      <span className={styles.pieLabelTime}>01:00 ～ 09:00</span>
    </div>
  </foreignObject>
</svg>
              <div className={styles.pieCenterClock}>
                <IconClock />
              </div>
            </div>
            <div className={styles.badgeYellow}>
              <IconCheckFilled bg="#0B1E3D" />
              どの時間帯でもトライアル可能！
            </div>
          </div>
        </div>

        {/* Right column: flow + benefits, now two distinct panels */}
        <div className={styles.rightCol}>
          <div className={styles.panel}>
            <div className={styles.panelHeader}>トライアルの流れ</div>
            <div className={styles.panelBody}>
              {/* Change 2026-08-13 : Commented old code, below list is no more required */}
              {/*
              <ul className={styles.flowList}>
                <li>
                  <IconDocument />
                  申込は簡単（NDA入り申込書）
                </li>
                <li>
                  <IconGear />
                  専用フォームでスムーズ準備
                </li>
                <li>
                  <IconTarget />
                  KPI目標値を事前協議し納得の評価
                </li>
              </ul>
              */}

  <div className={styles.flowSteps}>
    {flowSteps.map((s, i) => (
      <React.Fragment key={s.num}>
        <div className={styles.flowStepCol}>
          {/* New change for design - 2026-08-13 */}
          <div className={styles.flowStep}>
            <span className={styles.flowStepIcon}>{s.icon}</span>
            <div className={styles.flowStepTitle}>
              {s.title}
            </div>
            <div className={styles.flowStepDescription}>
              {s.description}
            </div>
          </div>

        <div className={styles.flowStepBadge}>{s.num}</div>
        </div>
          {i < flowSteps.length - 1 && (
            <span className={styles.flowArrow}>
              <IconPlay />
            </span>
          )}
      </React.Fragment>
    ))}
  </div>
          </div>
          </div>

          <div className={styles.panel}>
            <div className={styles.panelHeader}>トライアルのメリット</div>
            <div className={styles.panelBody}>
              <div className={styles.benefitsRow}>
                {benefits.map((b, i) => (
                  <div className={styles.benefitItem} key={i}>
                    <div className={styles.benefitIcon}>{b.icon}</div>
                    <div className={b.highlight ? styles.benefitTextHighlight : styles.benefitText}>
                      {b.text}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guidance notes */}
      {/* Guidance notes */}
<section className={styles.notesSection}>
  <div className={styles.notesCard}>
    <p className={styles.notesTitle}>お申込みにあたってのご案内事項（4項目）</p>
    <div className={styles.notesGrid}>
                  {notes.map((n) => (
        <div className={styles.noteItem} key={n.label}>
          <IconCheckFilled />
          <div className={styles.noteContent}>
            <p className={styles.noteText}>
              <span className={styles.noteLabel}>{n.label}：</span>
              {n.text}
            </p>
            {n.label === "申込書兼オンライン同意" && (
              <a
                href={mspTrialApplicationPdf}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.notePdfButton}
              >
                <IconDocument /> MSP サービス トライアル申込書
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Final CTA */}
      <section className={styles.footerBand}>
        <div className={styles.footerLeft}>
          <span className={styles.footerEnvelope}>
            <IconEnvelope />
          </span>
          <Link to="/jp/contact" className={styles.footerText}>
            まずはお気軽にご相談ください
          </Link>
        </div>
        <a
          href={CONSULTATION_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ctaButton}
        >
          無料オンライン相談の申し込み <span className={styles.ctaArrow}>›</span>
        </a>
      </section>

      <div className={styles.collapseButtonWrap}>
        <Link to="/jp" className={styles.collapseButton}>
          ▲ 閉じる
        </Link>
      </div>
    </div>
  );
};

export default CampaignbannerPage;